import React from 'react';
import Settings from '../Settings';
import { useAuth } from '../AuthProvider';
import Login from '../Login';
import { useNavigate } from 'react-router-dom';
import PageWrapperAuto from '../components/PageWrapperAuto';

export default function SettingsPage() {
  const { user, logOut } = useAuth();
  const navigate = useNavigate();

  if (!user) return (
    <PageWrapperAuto>
      <Login />
    </PageWrapperAuto>
  );

  return (
    <PageWrapperAuto>
<div className="settings-page">
<Settings onBack={() => navigate(-1)} />

<div style={{ maxWidth: '240px', margin: '0px auto' }}>
  <button className="btn-subtle search-control-btn" onClick={logOut} style={{ width: '100%', fontSize: 'var(--ui-compact-font)', padding: '6px 10px' }}>
    Log Out
  </button>
</div>
</div>

    </PageWrapperAuto>
  );
}
